import { HeaderMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import { makeDarker } from '@/helpers'
import { Coordinate2D } from '@/types'
import Konva from 'konva'

const DEFAULT_STROKE_COLOUR = '#6C757D'
const HIGHLIGHTED_STROKE_COLOUR = 'black'
const SELECTED_STROKE_LIGHTNESS_REDUCTION = 20
const DEFAULT_STROKE_WIDTH = 3
const BOLD_STROKE_WIDTH = 6

export class HeaderRectV2 extends Konva.Rect implements Shapes.Shape, Shapes.Highlightable {
  private _metadata: HeaderMetadata
  private _highlighted: boolean = false
  private _selected: boolean = false
  capabilities: Shapes.Capability[] = [
    Shapes.Capability.Selectable,
    Shapes.Capability.Highlightable,
  ]

  constructor(metadata: HeaderMetadata) {
    super({
      cornerRadius: 10,
    })
    this._metadata = metadata
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center(): Coordinate2D {
    return {
      x: this.x() + this.width() / 2,
      y: this.y() + this.height() / 2,
    }
  }

  get isHighlighted(): boolean {
    return this._highlighted
  }

  set isHighlighted(value: boolean) {
    this._highlighted = value
    this.updateStroke()
  }

  get isSelected(): boolean {
    return this._selected
  }

  set isSelected(value: boolean) {
    this._selected = value
    this.updateStroke()
  }

  refresh() {
    this.updateSize()
    this.updateOffset()
    this.updateFill()
    this.updateStroke()
  }

  private updateSize() {
    this.width(this._metadata.size.width)
    this.height(this._metadata.size.height)
  }

  private updateOffset() {
    this.offsetX(this.width() / 2)
    this.offsetY(this.height() / 2)
  }

  private updateFill() {
    this.fill(this._metadata.storyColour)
  }

  private updateStroke() {
    if (this.isHighlighted) {
      this.stroke(HIGHLIGHTED_STROKE_COLOUR)
      this.strokeWidth(BOLD_STROKE_WIDTH)
    } else if (this.isSelected) {
      this.stroke(makeDarker(this._metadata.storyColour, SELECTED_STROKE_LIGHTNESS_REDUCTION))
      this.strokeWidth(BOLD_STROKE_WIDTH)
    } else {
      this.stroke(DEFAULT_STROKE_COLOUR)
      this.strokeWidth(DEFAULT_STROKE_WIDTH)
    }
  }
}
